// Dependencies
import { z } from "zod";

// local imports
import request from "../base-request";

export const navigationConfigSchema = z.object({
	currentUserId: z.string(),
	currentUserName: z.string(),
	currentUserJobTitle: z.string(),
	companyId: z.string(),
	theUserId: z.string(),
	isViewingSelf: z.boolean(),
	currentNav: z.string().nullable(),
	isAdmin: z.boolean(),
	isBasicAdmin: z.boolean(),
	isEngagementOnly: z.boolean(),
	isOverlord: z.boolean(),
	possessor: z
		.object({
			name: z.string(),
			id: z.string(),
		})
		.nullable(),
	visibleNavTags: z.record(z.string(), z.array(z.string())).optional(),
	navColor: z.string(),
	iconColor: z.string(),
	currentPromotion: z.record(z.string(), z.unknown()),
	logoUrl: z.string(),
	mobileLogoUrl: z.string(),
});

export const navigationConfigResponseSchema = z.object({
	navigationConfig: navigationConfigSchema,
});

export type NavigationConfig = z.infer<typeof navigationConfigSchema>;
export type NavigationConfigResponse = z.infer<typeof navigationConfigResponseSchema>;

/**
 * Get navigation config for current viewing context.
 * Optionally pass employeeId to get config for viewing a specific employee.
 */
export const getNavigationConfig = async (employeeId?: string) => {
	const url = employeeId ? `/api/navigation-config?employeeId=${employeeId}` : "/api/navigation-config";
	const [data] = await request(url);
	return navigationConfigResponseSchema.parse(data);
};
